import { FEATURES } from '@constants/Text'

export default [
  {
    path: '/lista-espera',
    name: 'lista-espera',
    component: () =>
      import('@modules/professional-waitlist/views/view-lista-espera.vue'),
    meta: { restrito: true, can_show: FEATURES.LISTA_ESPERA },
  },
]
